'use strict';

app.directive('rmTopnav', function ($timeout) {
  return {
    scope: true,
    templateUrl: '/app/states/topnav/topnav.html',
    controller: function ($scope) {
      $scope.scored = 0;
      var timer;
      $scope.$watch('user.points', function (next, prev) {
        if (!next || next === prev) { return; }
        $scope.scored = next - prev;
        $timeout.cancel(timer);
        timer = $timeout(function () {
          $scope.scored = 0;
        }, 6000);
      });
    }
  };
});
